import axios from "axios";

const language = window.localStorage.getItem("language") || "ru";

export const BACKEND_URL = "https://api.homescare.uz/";
export const API_URL = `${BACKEND_URL}${language}`;

export const $host = axios.create({
  baseURL: API_URL,
  headers: {
    "Accept-Language": language,
  },
});

export const fetchCategories = async () => {
  try {
    const { data } = await $host.get("/products/api/v1/categories/");
    return data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchCategoriesFull = async () => {
  try {
    const { data } = await $host.get("/products/test-categories/");
    return data;
  } catch (e) {
    console.log(e);
  }
};

const normalizeApiList = (data) => {
  if (Array.isArray(data)) return data;
  if (data?.results && Array.isArray(data.results)) return data.results;
  return [];
};

export const fetchSubcategories = async () => {
  try {
    const { data } = await $host.get("/products/api/v1/subcategories/");
    return normalizeApiList(data);
  } catch (e) {
    console.log(e);
    return [];
  }
};

export const fetchCategoriesWithSubcategories = async () => {
  try {
    const [categoriesResponse, subcategories] = await Promise.all([
      $host.get("/products/api/v1/categories/"),
      fetchSubcategories(),
    ]);

    const categories = normalizeApiList(categoriesResponse.data);
    const subcategoriesByCategory = subcategories.reduce((acc, sub) => {
      const categoryId = sub.category?.id;
      if (!categoryId) return acc;
      if (!acc[categoryId]) acc[categoryId] = [];
      acc[categoryId].push(sub);
      return acc;
    }, {});

    return categories.map((category) => ({
      ...category,
      subcategories: subcategoriesByCategory[category.id] || [],
    }));
  } catch (e) {
    console.log(e);
    return [];
  }
};

export const fetchProducts = async () => {
  try {
    const { data } = await $host.get("/products/api/v1/products/");
    return data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchPartners = async () => {
  try {
    const { data } = await axios.get(
      `${BACKEND_URL}en/others/api/v1/partners/`,
    );
    return data;
  } catch (e) {
    console.log(e);
  }
};
